import { PJAxios, setOfflineBundles, useCoreContext, useGetText, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';
import isFilled from '../../Utils';

function LinkDetail(props) {
    const [nameIt, setNameIt] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [loading, setLoading] = useState(false);

    const getText = useGetText();
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const bundles = useCoreContext((state) => state.i18n.bundles);

    useEffect(() => {
        if (props.selectedNode) {
            const bundleTitle = props.selectedNode.title;
            setNameIt(bundles?.it?.[bundleTitle] || '');
            setNameEn(bundles?.en?.[bundleTitle] || '');
        }
    }, [props.selectedNode, bundles]);

    const validateForm = () => {
        return isFilled(nameIt) && isFilled(nameEn);
    };

    const aggiornaBundles = () => {
        const bundle = props.selectedNode.title;
        setOfflineBundles({
            it: { [bundle]: nameIt },
            en: { [bundle]: nameEn }
        });
    };

    const salvaTutto = () => {
        setLoading(true);

        const modifiedNodes = [
            {
                is_new: false,
                id_item: props.selectedNode.idItem,
                id_element: "nomel_it",
                op_type: "mod_el",
                obj_type: "link",
                new_val: nameIt
            },
            {
                is_new: false,
                id_item: props.selectedNode.idItem,
                id_element: "nomel_en",
                op_type: "mod_el",
                obj_type: "link",
                new_val: nameEn
            }
        ];

        PJAxios()
            .post('/gestioneConfigurazioni/salvaTutto', {
                operazioni: modifiedNodes,
                idConfig: props.tematica.id_config
            })
            .then(() => {
                aggiornaBundles();
                props.onSave(props.tematica, true);
                flushCache(dbTest);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {loading && <ProgressSpinner />}

            {!loading &&
                <div className="p-fluid grid">
                    <div className="field col-12 md:col-12">
                        <span style={{ textAlign: "left", textTransform: "uppercase" }}>
                            <h6><b>{getText("MODIFICA_TEMATICA")}</b></h6>
                        </span>

                        <div className="field col-12 md:col-12">
                            {getText("NOME_IT")}
                            <InputText
                                className="width500px p-inputtext-sm block mb-2"
                                value={nameIt}
                                onChange={(e) => setNameIt(e.target.value)}
                            />
                        </div>

                        <div className="field col-12 md:col-12">
                            {getText("NOME_EN")}
                            <InputText
                                className="width500px p-inputtext-sm block mb-2"
                                value={nameEn}
                                onChange={(e) => setNameEn(e.target.value)}
                            />
                        </div>

                        <div className="field col-3 md:col-3">
                            <Button
                                disabled={!validateForm()}
                                label={getText("SALVA")}
                                onClick={salvaTutto}
                                icon="pi pi-save"
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default LinkDetail;